// just an interface for type safety.
export class Marker {
	id: number;
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
	icon: string;
	isOnline: boolean;
	data: any;
}



// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/view-model/marker.viewModel.ts